<template>
    <div id="monitor-table-page" 
        class="monitor-table-page"
        :class="{
            'monitor-table-page--open-chart': is_show_chart_dialog,
            'monitor-table-page--open-map': is_monitor_open_emap
        }"
    >
        <div class="monitor-table-page__title">
            <h2 :style="{'font-size': `${title_size}px`}">
                {{ table_title }}
            </h2>
            <div 
                v-if="is_current_monitor" 
                class="description"
            >
                <slot name="description" />
            </div>

            <div 
                v-if="!is_current_monitor" 
                class="description"
            >
                <slot name="description_history" />
            </div>
        </div>
        <div 
            v-if="history_monitor_list.includes(default_value) && !in_overview_page"
            id="monitor-switch"
            style="margin: 5px 0;"
        >
            <v-btn 
                id="current-monitor-btn"
                :ripple="false" 
                :color="is_current_monitor ? '#8dba6f' : '#b7cda8'"
                :class="is_current_monitor ? 'btn-clicked' : 'btn-unclicked'"
                @click="is_current_monitor = true"
            > 
                即時監測 
            </v-btn>
            <v-btn 
                id="history-monitor-btn"
                :ripple="false" 
                :color="is_current_monitor ? '#b7cda8' : '#8dba6f'"
                :class="is_current_monitor ? 'btn-unclicked' : 'btn-clicked'"
                @click="is_current_monitor = false"
            > 
                歷史燈號 
            </v-btn>
        </div>
        
        <!-- 日期時間選擇區塊 (給沒有歷史燈號功能的監控產品 及 THB 即時監測 使用)-->
        <div style="display: inline-block; margin-left: 15px;">
            <slot 
                v-if="!history_monitor_list.includes(default_value) || is_current_monitor" 
                name="datetime" 
            />
        </div>

        <div id="signs-wrapper">
            <slot 
                v-if="is_current_monitor"
                name="signs"
            />
        </div>

        <div id="control-table-tool" 
            class="control-table-tool"
            :style="(is_current_monitor) ? '' : 'margin-bottom: -20px'"
        >
            <div class="start">
                <slot 
                    v-if="!is_current_monitor" 
                    name="datetime_interval" 
                />
                <slot name="filter_condition_options">
                    <span />
                </slot>
            </div>
            <div class="end">
                <slot name="description_th" 
                />
                <SearchField v-show="show_search_text"
                    :search.sync="search"
                /> 
            </div>
        </div>
        
        <div class="monitor-table-page__table-wrapper">
            <slot 
                v-if="is_current_monitor"
                name="data_table"
                :search="search"
            />
        </div>

        <div class="history-data-table">
            <slot 
                v-if="!is_current_monitor"
                name="history_data_table"
                :search="search"
                :search_column="search_column"
            />
        </div>

        <div class="hint-dialog">
            <slot 
                v-if="!is_current_monitor"
                name="hint_dialog"
            />
        </div>
    </div>
</template>

<script>
    import { mapState, mapGetters } from 'vuex'
    import SearchField from "@/components/monitor/search_field.vue"
    
    export default {
        name: 'MonitorLayoutTemplate',

        components: {
            SearchField,
        },

        props: {
            is_show_chart_dialog: {
                type: Boolean,
                default: false,
            },

            table_title: {
                type: String,
                require: true,
                default: 'plz props title'
            },

            title_size: {
                type: Number,
                default: 20
            },

            show_search_text: {
                type: Boolean,
                default: true,
            },

            default_value: {
                type: Number,
                default: -1
            },

            in_overview_page: {
                type: Boolean,
                default: false
            },
        },

        computed: {
            ...mapState('emap-monitor', [
                'is_monitor_open_emap',
            ]),

            ...mapGetters([
                'is_mobile_width'
            ]),

            search_column(){
                if(this.default_value === 26) return ['路段', '工務段', '分駐所']
                if(this.default_value === 27) return ['橋梁', '工務段', '分駐所']
                
                return ['所屬單位', '路段']
            }
        },

        data() {
            return {
                search: '',
                is_current_monitor: true,
                history_monitor_list: [2, 3, 4, 5, 8, 26, 27], // 需要有歷史燈號功能的監控產品清單 
            }
        },
    }
</script>

<style lang="scss" scoped>
    @import '../../../../css/mixin';

    .monitor-table-page {
        @include desktop {
            overflow: auto;
            max-height: 90vh;
            transition: max-height .8s ease-out;
            margin-bottom: 10px;
        }

        &--open-chart {
            @include desktop {
                max-height: 45vh;
            }
        }

        &--open-map {
            @include desktop {
                max-height: initial;
            }
        }


        &__title {
            border-bottom: 1px solid var(--grey-border);
            display: flex;
            align-items: center;
            gap: 1rem;
            padding: 0 1rem;

            @include tablet {
                flex-wrap: wrap;
            }

            @include mobile {
                flex-flow: column;
                align-items: flex-start;
                gap: 0;
            }
        }

        &__table-wrapper {
            margin-top: 1.5rem;
        }
    }

    .control-table-tool {
        display: flex;
        justify-content: space-between;
        margin: 0 1rem;

        .start, .end {
            display: flex;
            align-items: baseline;
            gap: 1rem;
        }
    }

    .description {
        display: flex;
        flex-wrap: wrap;
        margin-left: auto;

        @include mobile {
            margin-left: initial;
            padding: 0 0 1rem;
        }
    }

    .btn-unclicked{
        color: #7c8c71;
        box-shadow: none; 
        margin-left: 15px;
    }

    .btn-clicked{
        color: white; 
        box-shadow: none; 
        margin-left: 15px;
    }

    .history-data-table{
        @include desktop {
            overflow: auto;
            max-height: 90vh;
            transition: max-height .8s ease-out;
        }
    }
</style>